import { useSelector } from "react-redux";
import { RootState } from "store";

export const useHistoryUserLocation = () => {
  const historyUserLocation = useSelector(
    (state: RootState) => state["USER"].historyUserLocation
  );
  return historyUserLocation.data;
};
